import { isObject, validateString } from '..'
import { VALIDATION_FIELDS } from '../validators'

export const INSTITUTION_VALIDATORS = [
  { key: VALIDATION_FIELDS.ACRONYM, validator: ig => validateString(ig.acronym, { notEmpty: true }) },
  { key: VALIDATION_FIELDS.COUNTRY, validator: ig => isObject(ig.country) },
  { key: VALIDATION_FIELDS.NAME, validator: ig => validateString(ig.name, { notEmpty: true }) }
]

export const getName = i => {
  return i.name
}

export const getAcronym = i => {
  return i.acronym
}

export const getAddress = i => {
  return i.address
}

export const getCity = i => {
  return i.city
}

export const getCountry = i => {
  return isObject(i.country) ? i.country.name : null
}

export const getDescription = i => {
  return i.description
}

export const getZipcode = i => {
  return i.zipcode
}

export class Institution {
  constructor ({ id, acronym, address, city, country, description, managed, name, zipcode } = {}) {
    this.id = id ?? -1
    this.acronym = acronym ?? ''
    this.address = address ?? ''
    this.city = city ?? ''
    this.country = country ?? null
    this.description = description ?? ''
    this.managed = managed ?? false
    this.name = name ?? ''
    this.zipcode = zipcode ?? ''
  }

  toRequestBody = () => {
    return {
      id: this.id,
      acronym: this.acronym,
      address: this.address,
      city: this.city,
      country: this.country === null ? null : this.country.code,
      description: this.description,
      managed: this.managed,
      name: this.name,
      zipcode: this.zipcode
    }
  }
}
